import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 8l0 4l2 2","key":"svg-0"}],["path",{"d":"M3.05 11a9 9 0 1 1 .5 4m-.5 5v-5h5","key":"svg-1"}]]

/**
 * IconHistory
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItaGlzdG9yeSIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTIgOGwwIDRsMiAyIiAvPgogIDxwYXRoIGQ9Ik0zLjA1IDExYTkgOSAwIDEgMSAuNSA0bS0uNSA1di01aDUiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/history
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconHistory = createReactComponent('outline', 'history', 'History', __iconNode);

export default IconHistory;